<div class="internal-message-holder" *ngIf="pinnedMessage">
    <div class="message">
        <div class="message-header">
            <div class="message-author">{{ pinnedMessage.from }}</div>
            <div class="message-time">{{ pinnedMessage.timestamp | date: 'HH:mm' }}</div>
        </div>
        <div class="message-text">{{ pinnedMessage.content }}</div>
    </div>
</div>

<div class="messages-holder" [class.empty]="!messages || !messages.length || !chatEnabled">
    @if (chatEnabled) {
        <div i18n class="chat-title">Chat</div>
        <div class="messages" #messagesEl [class.messages-scrollbar]="scrollBarIsVisible">
            @for (message of messages; track message) {
                <div class="message">
                    <div class="message-header">
                        <div class="message-author">{{ message.from }}</div>
                        <div class="message-time">{{ message.timestamp | date: 'HH:mm' }}</div>
                    </div>
                    <div class="message-text">{{ message.content }}</div>
                </div>
            } @empty {
                <div i18n class="message-warning">No messages</div>
            }
        </div>
    } @else {
        <div i18n class="message-warning">Chat is disabled</div>
    }
    <button i18n class="button-game button-game-max-width" (click)="toggleClicked.emit(toggleChatButton)" #toggleChatButton>
        @if (chatEnabled) {
            Disable chat
        } @else {
            Enable chat
        }
    </button>
</div>
